import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsPivotGridComponent } from './transport-interventions-pivot-grid.component';
import {DxPivotGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [TransportInterventionsPivotGridComponent],
    imports: [
        CommonModule,
        DxPivotGridModule
    ],
  exports: [TransportInterventionsPivotGridComponent]
})
export class TransportInterventionsPivotGridModule { }
